import { render } from "./FermeVue.vue?vue&type=template&id=616cf2a7"
import script from "./FermeVue.vue?vue&type=script&lang=js"
export * from "./FermeVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__